import type { State } from '../../types';
import type { PartnerViewModel } from '@trinnvis/dabih-api-client';

import { toList } from '../toList';

export function getPartners(state: State): PartnerViewModel[] {
  return state.organization !== undefined ? toList(state.organization.partnersById) : [];
}
